import apiDateToDateTime from './apiDateToDateTime';

// https://moment.github.io/luxon/#/

type Variant = 'table' | 'label' | 'shortlabel' | 'short' | '24hrutc' | '12hrlocal';

// TODO: Move format strings to file so as to use with places we already have a DateTime

/**
 * Tables: 24hr time, UTC label in the table header
 * Labels in the UI: 12hr time (as noted in the ticket above)
 * Some labels do not show seconds if we don't have or want to show that level of accuracy.
 *
 * See: https://www.notion.so/teamhologram/Hologram-Writing-Guide-d85fbb8709e64fdc84374b76f937b566?pvs=4#c177d10d80d741d990c8fa761c6ba49e
 * And: https://www.notion.so/teamhologram/Hologram-Writing-Guide-d85fbb8709e64fdc84374b76f937b566?pvs=4#97171cc3105a4b089d564a717bc25bed
 */
const formatDateTime = (rawDate?: string, variant: Variant = 'label') => {
  if (!rawDate) {
    return undefined;
  }

  const internalDate = apiDateToDateTime(rawDate);

  if (!internalDate) {
    return undefined;
  }

  switch (variant) {
    case 'table':
      return internalDate.toFormat('MM-dd-yy hh:mm:ss a');

    case 'shortlabel':
      return internalDate.toFormat('MM-dd-yy hh:mm a ZZZZ');

    case 'short':
      return internalDate.toFormat('MM-dd-yy HH:mm:ss');

    case '24hrutc':
      return internalDate.toFormat('MM-dd-yy HH:mm:ss ZZZZ');

    case '12hrlocal':
      return internalDate.toLocal().toFormat('MM-dd-yy ttt');

    case 'label':
    default:
      return internalDate.toFormat('MM-dd-yy hh:mm:ss a ZZZZ');
  }
};

export default formatDateTime;
